import { useEffect } from 'react'

interface SEOProps {
  title?: string
  description?: string
  keywords?: string
  canonical?: string
  ogImage?: string
  structuredData?: object
}

const SEO: React.FC<SEOProps> = ({
  title = 'Parth Video - Best Video Production & Event Management Company in Ahmedabad',
  description = 'Parth Video - Ahmedabad\'s #1 professional video production and event management company since 1999. Expert wedding videography, corporate events, photography, live streaming services in Gujarat.',
  keywords = 'video production Ahmedabad, event management Ahmedabad, wedding videography Ahmedabad, corporate video production Gujarat, photography services Ahmedabad, live streaming Ahmedabad, event planning Ahmedabad, professional photographer Ahmedabad, video production company Gujarat, best event management Ahmedabad, commercial video production, Parth Video Ahmedabad, video editing services, corporate events Ahmedabad, wedding photography Gujarat',
  canonical,
  ogImage = '/og-image.jpg',
  structuredData
}) => {
  useEffect(() => {
    // Update document title
    document.title = title

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', description)
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords)
    }

    // Update Open Graph title
    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) {
      ogTitle.setAttribute('content', title)
    }

    // Update Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]')
    if (ogDescription) {
      ogDescription.setAttribute('content', description)
    }

    // Update Open Graph image
    const ogImageMeta = document.querySelector('meta[property="og:image"]')
    if (ogImageMeta) {
      ogImageMeta.setAttribute('content', ogImage)
    }

    // Update Twitter title
    const twitterTitle = document.querySelector('meta[property="twitter:title"]')
    if (twitterTitle) {
      twitterTitle.setAttribute('content', title)
    }

    // Update Twitter description
    const twitterDescription = document.querySelector('meta[property="twitter:description"]')
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description)
    }

    // Update Twitter image
    const twitterImage = document.querySelector('meta[property="twitter:image"]')
    if (twitterImage) {
      twitterImage.setAttribute('content', ogImage)
    }

    // Add canonical URL if provided
    if (canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]')
      if (!canonicalLink) {
        canonicalLink = document.createElement('link')
        canonicalLink.setAttribute('rel', 'canonical')
        document.head.appendChild(canonicalLink)
      }
      canonicalLink.setAttribute('href', canonical)
    }

    // Add structured data if provided
    if (structuredData) {
      let structuredDataScript = document.querySelector('script[data-seo="structured-data"]')
      if (!structuredDataScript) {
        structuredDataScript = document.createElement('script')
        structuredDataScript.setAttribute('type', 'application/ld+json')
        structuredDataScript.setAttribute('data-seo', 'structured-data')
        document.head.appendChild(structuredDataScript)
      }
      structuredDataScript.textContent = JSON.stringify(structuredData)
    }
  }, [title, description, keywords, canonical, ogImage, structuredData])

  return null
}

export default SEO